export const monthList = [
    {
        index: 1,
        name: 'มกราคม'
    },
    {
        index: 2,
        name: 'กุมภาพันธ์'
    },
    {
        index: 3,
        name: 'มีนาคม'
    },
    {
        index: 4,
        name: 'เมษายน'
    },
    {
        index: 5,
        name: 'พฤษภาคม'
    },
    {
        index: 6,
        name: 'มิถุนายน'
    },
    {
        index: 7,
        name: 'กรกฎาคม'
    },
    {
        index: 8,
        name: 'สิงหาคม'
    },
    {
        index: 9,
        name: 'กันยายน'
    },
    {
        index: 10,
        name: 'ตุลาคม'
    },
    {
        index: 11,
        name: 'พฤศจิกายน'
    },
    {
        index: 12,
        name: 'ธันวาคม'
    },
];